import React from 'react';
import {FlatList, ScrollView, Text, TouchableOpacity} from 'react-native';
import {styles} from './styles.web';

import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import {StackParams} from '../../../../data/types/navigation';

type Props = {
  data: {
    id: string;
    libelle: string;
  }[];
};

type NavigationProps = StackNavigationProp<StackParams, 'Glossaire'>;

export function ListSimple({data}: Props) {
  const {navigate} = useNavigation<NavigationProps>();

  return (
    <ScrollView>
      <FlatList
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        keyExtractor={(item: any) => item.id}
        data={data}
        renderItem={({item}) => (
          <TouchableOpacity
            onPress={() =>
              navigate('Glossaire', {data: item.id, libelle: item.libelle})
            }
            style={styles.headerSpace}>
            <Text style={styles.headerText}>{item.libelle}</Text>
          </TouchableOpacity>
        )}
      />
    </ScrollView>
  );
}
